module.exports = __webpack_public_path__ + "media/investors/hero-557fa1f5.jpg";